// import axios from 'axios'
import i18n from "@/lang/i18n";
import store from "../store";
import router from "@/router";
// import Qs from "qs";

import { getToken, setToken } from "@/utils/auth";
// import { DeviceUtil } from "./deviceUtil";
// import axios from "axios";
// import { Message, MessageBox } from "element-ui";
// import Cookies from "js-cookie";

axios.defaults.headers.common["Content-Type"] =
  "application/json;charset=UTF-8";
axios.defaults.withCredentials = true;

// 创建axios实例
const service = axios.create({
  // paramsSerializer: function(params) {
  //   return Qs.stringify(params, {arrayFormat: "repeat"})
  // },
  baseURL: '/api', // api 的 base_url
  timeout: 60000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers["Cache-Control"] = "no-cache"; //解决IE相同请求有缓存问题
    config.headers[`${process.env.VUE_APP_AUTH_TOKEN}`] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers["Accept-Language"] = localStorage.getItem("lang");
    if (config.data && config.data["X-IDEMPOTENT-TOKEN"]) {
      config.headers["X-IDEMPOTENT-TOKEN"] = config.data["X-IDEMPOTENT-TOKEN"];
    }
    if (config.method === "get") {
      //如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
      config.paramsSerializer = function(params) {
        return Qs.stringify(params, {
          allowDots: true,
          arrayFormat: "indices"
        });
        // return Qs.stringify(params, {arrayFormat: 'indices'})
        // return Qs.stringify(params, {arrayFormat: 'repeat'})
      };
    }
    return config;
  },
  error => {
    console.log("request", error);
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    if (response.status === 200 && response.headers["authorization"]) {
      setToken(response.headers["authorization"]);
    }
    const res = response.data;
    if (res.code && res.code !== 0) {
      return doError(
        response.config.url,
        res.code === 401 || res.code === 403,
        res.code,
        res.msg
      );
    } else {
      // console.log("response", response.config.url, response.data);
      return response.data;
    }
  },
  error => {
    const response = error.response;
    if (response) {
      return doError(
        response.config.url,
        response.status === 401,
        response.status,
        null
      );
    } else {
      return doError("", false, "", error.message);
    }
  }
);

let toLoginMessageTime = null;

function doError(url, isLoginError, errCode, errMsg) {
  const simpleMsg = errMsg;
  url && (errMsg = url + "|" + errMsg);

  if (errCode !== -1) {
    //欠登录,就去登录
    if (isLoginError) {
      //登出
      store.dispatch("user/logout");

      //1秒内避免 重复弹窗
      let now = new Date().getTime();

      if (!toLoginMessageTime || now - toLoginMessageTime > 800) {
        toLoginMessageTime = now;
        ELEMENT.MessageBox({
          type: "warning",
          message: i18n.t("Please_Login_First"),
          showCancelButton: true,
          confirmButtonText: i18n.t("确认"),
          cancelButtonText: i18n.t("取消"),
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              // console.log('router.currentRoute',router)
              // console.log('router.currentRoute',router.currentRoute)
              // console.log('router.currentRoute',router.current.fullpath)
              // console.log('router.history.current',router.history.current)
              // console.log('router.currentRoute',router.history.current.fullPath)
              Cookies.set(
                "redirectPath",
                router.history.current.fullPath || ""
              );
              router.push("/login");
              // if (DeviceUtil.isAndroid() || DeviceUtil.isIOS()) {
              //   router.push("/login");
              // } else {
              //   router.push("/");
              // }
            }
            done();
          }
        }).catch();
      }
    } else {
      // if (errCode < 1000) {
      ELEMENT.Message({
        title: "Error",
        dangerouslyUseHTMLString: true,
        message: simpleMsg,
        type: "error",
        duration: 5 * 1000,
        showClose: true
      });
      // }
    }
  } else {
    ELEMENT.Message({
      title: "Error",
      dangerouslyUseHTMLString: true,
      message: simpleMsg,
      type: "error",
      duration: 5 * 1000,
      showClose: true
    });
    router.push("/");
  }
  console.log("Promise.reject");
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({ errCode, errMsg, msg: simpleMsg });
}

export default service;
export const get = service.get;
export const post = service.post;
